import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { authenticateUser, forgotPassword } from "../services/authService";
import { getPublicOverview } from "../services/statisticsService";
import { getUser, removeToken, removeUser, setToken, setUser } from "../utils/helper";
import "../assets/css/pages/login.css";

// Startise 4-colour brand mark.
function BrandLogo({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 512 512" aria-hidden="true">
      <path d="M233.237 355.464C233.237 408.279 190.422 451.072 137.63 451.072C84.8153 451.072 42 408.257 42 355.464H233.237Z" fill="#FDB849" />
      <path d="M177.079 61C102.504 61 42.0476 121.457 42.0476 196.031C42.0476 223.297 50.1305 248.692 64.0499 269.901C69.1596 277.698 75.0621 284.944 81.6033 291.485C106.028 315.91 139.792 330.997 177.079 330.997L272.576 61H177.079Z" fill="#09A7DF" />
      <path d="M470.727 156.608C470.727 103.793 427.912 61 375.12 61C322.305 61 279.512 103.815 279.512 156.608H470.749H470.727Z" fill="#665DA9" />
      <path d="M335.652 451.074C410.227 451.074 470.684 390.617 470.684 316.043C470.684 288.776 462.601 263.382 448.681 242.173C443.572 234.376 437.669 227.13 431.128 220.589C406.703 196.164 372.94 181.077 335.652 181.077L240.155 451.096H335.652V451.074Z" fill="#F0679F" />
    </svg>
  );
}

function SlackLogo() {
  return (
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_2415_8851)">
      <path d="M14.7407 21.085C12.4207 21.085 10.5391 22.9666 10.5391 25.2866V35.7966C10.5391 38.1166 12.4207 39.9983 14.7407 39.9983C17.0607 39.9983 18.9424 38.1166 18.9424 35.7966V25.2866C18.9407 22.9666 17.0591 21.085 14.7407 21.085Z" fill="#E91E63"/>
      <path d="M0.03125 25.287C0.03125 27.6087 1.91458 29.492 4.23625 29.492C6.55792 29.492 8.44125 27.6087 8.44125 25.287V21.082H4.23958C4.23792 21.082 4.23792 21.082 4.23625 21.082C1.91458 21.082 0.03125 22.9654 0.03125 25.287Z" fill="#E91E63"/>
      <path d="M14.7452 -0.00195312C14.7435 -0.00195312 14.7418 -0.00195312 14.7402 -0.00195312C12.4185 -0.00195312 10.5352 1.88138 10.5352 4.20305C10.5352 6.52471 12.4185 8.40805 14.7402 8.40805H18.9418V4.20305C18.9418 4.20138 18.9418 4.19805 18.9418 4.19471C18.9402 1.87638 17.0618 -0.00195312 14.7452 -0.00195312Z" fill="#00BCD4"/>
      <path d="M4.20891 18.95H14.7389C17.0606 18.95 18.9439 17.0667 18.9439 14.745C18.9439 12.4234 17.0606 10.54 14.7389 10.54H4.20891C1.88724 10.54 0.00390625 12.4234 0.00390625 14.745C0.00390625 17.0667 1.88724 18.95 4.20891 18.95Z" fill="#00BCD4"/>
      <path d="M35.7592 10.5381C33.4408 10.5381 31.5625 12.4164 31.5625 14.7348V14.7431V18.9481H35.7642C38.0858 18.9481 39.9692 17.0648 39.9692 14.7431C39.9692 12.4214 38.0858 10.5381 35.7642 10.5381C35.7625 10.5381 35.7608 10.5381 35.7592 10.5381Z" fill="#4CAF50"/>
      <path d="M21.0664 4.20362V14.7453C21.0664 17.0653 22.9481 18.947 25.2681 18.947C27.5881 18.947 29.4697 17.0653 29.4697 14.7453V4.20362C29.4697 1.88362 27.5881 0.00195312 25.2681 0.00195312C22.9481 0.00195312 21.0664 1.88362 21.0664 4.20362Z" fill="#4CAF50"/>
      <path d="M29.4697 35.7935C29.4697 33.4735 27.5881 31.5918 25.2681 31.5918H21.0664V35.7968C21.0681 38.1151 22.9481 39.9951 25.2681 39.9951C27.5881 39.9951 29.4697 38.1135 29.4697 35.7935Z" fill="#FF9800"/>
      <path d="M35.7975 21.082H25.2675C22.9458 21.082 21.0625 22.9654 21.0625 25.287C21.0625 27.6087 22.9458 29.492 25.2675 29.492H35.7975C38.1192 29.492 40.0025 27.6087 40.0025 25.287C40.0025 22.9654 38.1192 21.082 35.7975 21.082Z" fill="#FF9800"/>
      </g>
      <defs>
      <clipPath id="clip0_2415_8851">
      <rect width="40" height="40" fill="white"/>
      </clipPath>
      </defs>
    </svg>

  );
}

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [stats, setStats] = useState(null); // { totalMembers, totalCheckIns } from public overview
  const [forgotOpen, setForgotOpen] = useState(false);
  const [forgotSubmitting, setForgotSubmitting] = useState(false);

  useEffect(() => {
    if (getUser()) {
      navigate("/dashboard");
      return;
    }
    // No active session on the login screen — clear any orphaned auth keys so a
    // leftover bearer token can't survive a sign-out on a shared machine.
    removeUser();
    removeToken();
    document.title = "Sign in · Startise Attendance";
    getPublicOverview().then(setStats);
  }, [navigate]);

  const handleLogin = async (e) => {
    e?.preventDefault();
    setError("");
    if (!email || !password) {
      setError("Please enter your email and password.");
      return;
    }
    setSubmitting(true);
    const { user, token, status } = (await authenticateUser(email, password)) ?? {};
    setSubmitting(false);
    if (user) {
      setUser(user);
      setToken(token);
      navigate("/dashboard");
    } else if (status === 400) {
      setError("Invalid email or password. Please try again.");
    } else {
      toast.error("Something went wrong. Please try again.");
    }
  };

  const handleForgot = async (e) => {
    e?.preventDefault();
    setError("");
    if (!email) {
      setError("Enter your email and we'll DM you a reset link.");
      return;
    }
    setForgotSubmitting(true);
    const { message } = await forgotPassword(email);
    setForgotSubmitting(false);
    toast.success(message || "If that email belongs to an admin, a reset link has been sent on Slack.");
    setForgotOpen(false);
  };

  const openForgot = () => { setError(""); setForgotOpen(true); };

  const slackNotice = () => toast("Slack sign-in isn't enabled here — use your work email.");

  return (
    <div className="login-page">
      {/* Left branding panel */}
      <div className="login-left">
        <span className="blob blob-cyan" />
        <span className="blob blob-pink" />
        <div className="ll-top">
          <BrandLogo />
          <span className="brand">Startise</span>
        </div>
        <div className="ll-mid">
          <div className="ll-tag">Attendance · Admin Console</div>
          <h1>Every minute of your team, in one calm view.</h1>
          <p>Check-ins, remote days, breaks and late arrivals for your whole team — tracked in real time, ready when you are.</p>
          <div className="ll-stats">
            <div><div className="n">{stats ? stats.totalMembers : "—"}</div><div className="l">Team members</div></div>
            <div className="vr" />
            <div><div className="n">{stats ? Number(stats.totalCheckIns).toLocaleString() : "—"}</div><div className="l">Check-ins tracked</div></div>
          </div>
        </div>
        <div className="ll-foot">© {new Date().getFullYear()} Startise · Internal use only</div>
      </div>

      {/* Right form panel */}
      <div className="login-right">
        <div className="lr-card">
          <div className="lr-title">{forgotOpen ? "Reset your password" : "Welcome back"}</div>
          <div className="lr-sub">
            {forgotOpen
              ? "Enter your email and we'll DM you a reset link on Slack."
              : "Sign in to the attendance admin console."}
          </div>

          {forgotOpen ? (
            <form onSubmit={handleForgot}>
              <label htmlFor="forgot-email">Work email</label>
              <div className="input-wrap">
                <svg className="ic"><use href="#i-mail" /></svg>
                <input id="forgot-email" type="email" placeholder="admin@attendance.wpdeveloper.com" autoComplete="email" autoFocus value={email} onChange={(e) => setEmail(e.target.value)} />
              </div>

              <button className="signin-btn" type="submit" disabled={forgotSubmitting}>
                {forgotSubmitting ? "Sending…" : "Send reset link"}
              </button>

              {error && (
                <div className="login-err"><svg><use href="#i-warn" /></svg>{error}</div>
              )}

              <div style={{ textAlign: "center", marginTop: 14 }}>
                <button type="button" className="forgot" onClick={() => { setError(""); setForgotOpen(false); }}>
                  ← Back to sign in
                </button>
              </div>
            </form>
          ) : (
            <>
              <button type="button" className="slack-btn" onClick={slackNotice}>
                <SlackLogo />Continue with Slack
              </button>

              <div className="or"><span />or<span /></div>

              <form onSubmit={handleLogin}>
                <label htmlFor="email">Work email</label>
                <div className="input-wrap">
                  <svg className="ic"><use href="#i-mail" /></svg>
                  <input id="email" type="email" placeholder="admin@attendance.wpdeveloper.com" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                </div>

                <div className="pw-label">
                  <label htmlFor="password">Password</label>
                  <button type="button" className="forgot" onClick={openForgot}>Forgot?</button>
                </div>
                <div className="input-wrap">
                  <svg className="ic"><use href="#i-lock" /></svg>
                  <input id="password" type={showPw ? "text" : "password"} placeholder="Enter your password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} />
                  <button type="button" className="eye" onClick={() => setShowPw((v) => !v)} aria-label="Show password">
                    <svg><use href={`#i-${showPw ? "eye-off" : "eye"}`} /></svg>
                  </button>
                </div>

                <button className="signin-btn" type="submit" disabled={submitting}>
                  {submitting ? "Signing in…" : "Sign in"}
                </button>

                {error && (
                  <div className="login-err"><svg><use href="#i-warn" /></svg>{error}</div>
                )}
              </form>
            </>
          )}

          {/* <div className="lr-note">
            <svg><use href="#i-lock" /></svg>
            <div className="txt">Admin access is restricted to verified Startise leads. Default: <b>admin@attendance.wpdeveloper.com</b> · <b>12345678</b></div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Login;
